import { render, staticRenderFns } from "./training.vue?vue&type=template&id=9612e254&scoped=true"
import script from "./training.vue?vue&type=script&lang=js"
export * from "./training.vue?vue&type=script&lang=js"
import style0 from "./training.vue?vue&type=style&index=0&id=9612e254&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9612e254",
  null
  
)

export default component.exports